function upgradeCompanyPlanDialog () {
  return {
    restrict: 'E',
    templateUrl: '/core/dialogs/upgrade-company-plan/upgrade-company-plan-dialog.html?$$REVISION$$'
  }
}

export { upgradeCompanyPlanDialog }
